
  const MapNonClickablekpis = [
    {
      name: "Total Batteries Connected",
    },
  ];
  export { MapNonClickablekpis};
  